<ng-container *ngIf="showErrorBanner">
  <div class="error-banner-container">
    <div class="col-1 col-sm-1 col-md-1 col-lg-1">
      <div class="status-icon float-end">
        <i class="fa fa-exclamation-triangle warning-exclamation-icon fa-inverse"></i>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
      <p class="file-format-text" id="banner-error-msg">{{ showBannerErrorMsg }}</p>
    </div>
    <div class="col-1 col-sm-1 col-md-1 col-lg-1">
      <div class="exit-button float-end" (click)="closeMessageBanner()">
        <img src="assets/images/x_white.svg" />
      </div>
    </div>
  </div>
</ng-container>
<ng-container>
  <i class="details-text">{{ preliminaryDisclosureText }}</i>

  <h3 class="analyzer-details-title">Attributes</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header">
        <tr class="th_row">
          <th class="th_column details-attributes">
            <div class="th-column-padding">ATTRIBUTE</div>
          </th>
          <th class="th_column">ISSUANCE</th>
        </tr>
      </thead>

      <tbody id="collateral-analyzer-details-section-body">
        <tr class="td_row">
          <td class="td_cell">WA Net Interest Rate</td>
          <td class="td_cell">
            <ng-container *ngIf="netInterestRate === 0">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="netInterestRate !== 0">
              <span>{{ netInterestRate | number: '1.3-3' }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Interest Rate</td>
          <td class="td_cell">
            <ng-container *ngIf="waInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waInterestRate !== 'null'">
              <span>{{ waInterestRate }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Remaining Months to Maturity</td>
          <td class="td_cell">
            <ng-container *ngIf="WAMonthsToMaturity === ''">
              <span class="pr-20" *ngIf="!waRemainingMonthsToMaturityError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waRemainingMonthsToMaturityError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="WAMonthsToMaturity !== ''">
              <span>{{ WAMonthsToMaturity }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Loan Age</td>
          <td class="td_cell">
            <ng-container *ngIf="waLoanAge === 'null'">
              <span class="pr-20" *ngIf="!waLoanAgeError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waLoanAgeError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waLoanAge !== 'null'">
              <span>{{ waLoanAge }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Max Loan Size</td>
          <td class="td_cell">
            <ng-container *ngIf="maxLoanSize === 'null'">
              <span class="pr-20" *ngIf="!maxLoanSizeError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="maxLoanSizeError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="maxLoanSize !== 'null'">
              <span>{{ maxLoanSize | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Mortgage Loan Amount</td>
          <td class="td_cell">
            <ng-container *ngIf="waMortgageLoanAmount === 'null'">
              <span class="pr-20" *ngIf="!waMortgageLoanAmountError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waMortgageLoanAmountError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waMortgageLoanAmount !== 'null'">
              <span>{{ waMortgageLoanAmount | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Debt-To-Income (DTI)</td>
          <td class="td_cell">
            <ng-container *ngIf="waNetInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waNetInterestRate !== 'null'">
              <span> - </span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Loan-To-Value (LTV)</td>
          <td class="td_cell">
            <ng-container *ngIf="waLoanToValue === 'null'">
              <span class="pr-20" *ngIf="!waLoanToValueError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waLoanToValueError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waLoanToValue !== 'null'">
              <span>{{ waLoanToValue }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Borrower Credit Score</td>
          <td class="td_cell">
            <ng-container *ngIf="waBorrowerCreditScore === 'null'">
              <span class="pr-20" *ngIf="!waBorrowerCreditScoreError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waBorrowerCreditScoreError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waBorrowerCreditScore !== 'null'">
              <span>{{ waBorrowerCreditScore }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Loan Term</td>
          <td class="td_cell">
            <ng-container *ngIf="waOriginalLoanTerm === 'null'">
              <span class="pr-20" *ngIf="!waOriginalLoanTermError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waOriginalLoanTermError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waOriginalLoanTerm !== 'null'">
              <span>{{ waOriginalLoanTerm }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Average Mortgage Loan Amount</td>
          <td class="td_cell">
            <ng-container *ngIf="avgMortgageLoanAmount === 'null'">
              <span class="pr-20" *ngIf="!avgMortgageLoanAmountError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="avgMortgageLoanAmountError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="avgMortgageLoanAmount !== 'null'">
              <span>{{ avgMortgageLoanAmount | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Loan Count</td>
          <td class="td_cell">
            <ng-container *ngIf="loanCount === 'null'">
              <span class="pr-20" *ngIf="!loanCountError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="loanCountError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="loanCount !== 'null'">
              <span>{{ loanCount }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Delinquent Loans Purchased (Prior Month UPB)</td>
          <td class="td_cell">
            <ng-container *ngIf="waNetInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waNetInterestRate !== 'null'">
              <span> - </span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Eligible for Resecuritization</td>
          <td class="td_cell">
            <ng-container *ngIf="eligibleForResecuritization === 'null'">
              <span class="pr-20" *ngIf="!eligibleForResecuritizationError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="eligibleForResecuritizationError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="eligibleForResecuritization !== 'null'">
              <span>Yes</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Payment Delay Days</td>
          <td class="td_cell">
            <ng-container *ngIf="paymentDelayDays === 'null'">
              <span class="pr-20" *ngIf="!paymentDelayDaysError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="paymentDelayDaysError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="paymentDelayDays !== 'null'">
              <span>{{ paymentDelayDays }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Interest Only Security Indicator</td>
          <td class="td_cell">
            <ng-container *ngIf="interestOnlySecurityIndicator === 'null'">
              <span class="pr-20" *ngIf="!interestOnlySecurityIndicatorError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="interestOnlySecurityIndicatorError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="interestOnlySecurityIndicator !== 'null'">
              <span>{{ interestOnlySecurityIndicator }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Prepayment Penality Indicator</td>
          <td class="td_cell">
            <ng-container *ngIf="waNetInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waNetInterestRate !== 'null'">
              <span> - </span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Reduced Minimum Servicing Indicator</td>
          <td class="td_cell">
            <ng-container *ngIf="waNetInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waNetInterestRate !== 'null'">
              <span> - </span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Security Data Correction Indicator</td>
          <td class="td_cell">
            <ng-container *ngIf="waNetInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waNetInterestRate !== 'null'">
              <span> - </span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Security Notification Indicator</td>
          <td class="td_cell">
            <ng-container *ngIf="waNetInterestRate === 'null'">
              <span class="pr-20" *ngIf="!waNetInterestRateError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waNetInterestRateError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waNetInterestRate !== 'null'">
              <span> - </span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">WA Combined Loan-To-Value (CLTV)</td>
          <td class="td_cell">
            <ng-container *ngIf="waCombinedLTV === 'null'">
              <span class="pr-20" *ngIf="!waCombinedLTVError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="waCombinedLTVError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="waCombinedLTV !== 'null'">
              <span>{{ waCombinedLTV }}</span>
            </ng-container>
          </td>
        </tr>
        <tr class="td_row">
          <td class="td_cell">Third Party Origination UPB Percent</td>
          <td class="td_cell">
            <ng-container *ngIf="thirdPartyOriginationUPBPercent === 'null'">
              <span class="pr-20" *ngIf="!thirdPartyOriginationUPBPercentError"
                ><i
                  class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
                ></i
              ></span>
              <span class="pr-20" *ngIf="thirdPartyOriginationUPBPercentError">
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
              ></span>
            </ng-container>
            <ng-container *ngIf="thirdPartyOriginationUPBPercent !== 'null'">
              <span>{{ thirdPartyOriginationUPBPercent }}</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
